module.exports = "https://cdn.thelire.com/ins/resource/coins_store@3x.a6ee4ff1655c8aaaf9398b8375f40fee.png";